import React, { useEffect, useState } from "react";
import { GoDotFill } from "react-icons/go";
import SettingServices from "../../../services/SettingServices";

const DashboardOutlet = ({ user, data }) => {
  const stats = data?.stats || {};
  const wallet = data?.wallet;

  const [homeNotes, setHomeNotes] = useState([]);
  // One row per configured game, from the dashboard payload. This was two
  // booleans kept in local state and patched from three places, which could
  // only ever describe 3min and 5min.
  const games = data?.games || [];

  useEffect(() => {
    const settingApi = new SettingServices();
    const loadHomeNotes = async () => {
      try {
        const res = await settingApi.getSettingData();
        const settings = res?.data ?? res?.data?.data ?? null;
        const raw = settings?.home_notes;
        if (!raw) {
          setHomeNotes([]);
          return;
        }
        const parts = String(raw)
          .split("HomeNote")
          .map((p) => p.trim())
          .filter(Boolean);
        setHomeNotes(parts);
      } catch (err) {
        console.error("Error loading home notes (outlet dashboard):", err);
        setHomeNotes([]);
      }
    };
    loadHomeNotes();
  }, []);

  const liveCount = games.filter((g) => g.is_active).length;
  const walletBalance = Number(wallet?.wallet_balance || 0);
  const winningAmount = Number(wallet?.winning_amount || 0);

  return (
    <>
      <div className="dashboard-grid">
        <div className="stat-card">
          <div className="stat-icon">🔥</div>
          <div className="stat-content">
            <h3>Games Live</h3>
            {/* "3 / 4" plus one dot-chip per game, so the card stays the
                same height as its neighbours however many games exist. */}
            <p className="stat-value">
              {liveCount}
              <span className="stat-value-of">/ {games.length}</span>
            </p>
            <div className="adm-game-dots">
              {games.length === 0 ? (
                <span className="adm-game-dot adm-game-dot--stop">No games</span>
              ) : (
                games.map((g) => (
                  <span
                    key={g.id}
                    className={`adm-game-dot ${g.is_active ? "adm-game-dot--live" : "adm-game-dot--stop"}`}
                    title={g.is_active ? "Live" : "Stopped"}
                  >
                    <GoDotFill size={9} />
                    {g.game_name}
                  </span>
                ))
              )}
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <h3>Wallet Balance</h3>
            <p className="stat-value">₹{walletBalance.toFixed(2)}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🏆</div>
          <div className="stat-content">
            <h3>Winning Amount</h3>
            <p className="stat-value">₹{winningAmount.toFixed(2)}</p>
          </div>
        </div>
      </div>

      {homeNotes.length > 0 && (
        <div className="dashboard-mobile-home-notes">
          <h2 className="dashboard-mobile-home-notes-title">Home Notes</h2>
          <div className="dashboard-mobile-home-notes-list">
            {homeNotes.map((note, idx) => (
              <p key={idx} className="dashboard-mobile-home-note">
                {note}
              </p>
            ))}
          </div>
        </div>
      )}

      <div className="recent-activity">
        <h2>Outlet Dashboard</h2>
        <p className="activity-desc">
          Use &quot;Outlet Live Session&quot; to run the game and place bets for
          your outlet. Running sessions, wallet balance, and winning amount are
          shown above.
        </p>
      </div>
    </>
  );
};

export default DashboardOutlet;
